export async function createAudioProcessor({ inputStream, settings, debug, lipSyncEngine } = {}) {
  try {
    const audioTracks = inputStream?.getAudioTracks && inputStream.getAudioTracks()
    if (settings?.animateMouth && audioTracks && audioTracks.length) {
      const AudioCtor =
        typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext)
      if (!AudioCtor)
        return {
          audioContext: null,
          analyser: null,
          analyserData: null,
          lipSyncNode: null,
          dispose: () => {}
        }
      const audioContext = new AudioCtor()
      const source = audioContext.createMediaStreamSource(inputStream)

      let lipSyncNode = null
      if (settings.lipSyncProfile) {
        try {
          lipSyncNode = await (lipSyncEngine && lipSyncEngine.createNode
            ? lipSyncEngine.createNode(audioContext, settings.lipSyncProfile)
            : null)
          if (lipSyncNode) {
            try {
              source.connect(lipSyncNode)
            } catch (e) {}
            debug && debug('wLipSync initialized.')
          }
        } catch {
          lipSyncNode = null
        }
      }

      const analyser = audioContext.createAnalyser()
      analyser.fftSize = 512
      analyser.smoothingTimeConstant = 0.7
      const analyserData = new Uint8Array(analyser.fftSize)
      try {
        source.connect(analyser)
      } catch (e) {}

      const dispose = () => {
        try {
          try {
            analyser.disconnect && analyser.disconnect()
          } catch (e) {}
          try {
            lipSyncNode && lipSyncNode.disconnect && lipSyncNode.disconnect()
          } catch (e) {}
          try {
            if (audioContext && audioContext.state !== 'closed' && audioContext.close) {
              const p = audioContext.close()
              if (p && typeof p.catch === 'function') p.catch(() => {})
            }
          } catch (e) {}
        } catch (e) {}
      }

      return { audioContext, analyser, analyserData, lipSyncNode, dispose }
    }
    debug && debug('No audio tracks available; mouth animation disabled.')
  } catch (e) {
    // ignore and fall through
  }
  return {
    audioContext: null,
    analyser: null,
    analyserData: null,
    lipSyncNode: null,
    dispose: () => {}
  }
}

export default { createAudioProcessor }
